import { usePromotionsData, PromotionBanner } from '@saatva-bits/pattern-library.modules.promotions'

import { useFeatureFlag } from '@saatva-bits/pattern-library.modules.launch-darkly'

export default function Banner({ mktChannel }) {
    const promotionData = usePromotionsData()

    const { isOn: enableCSRPersonalization } = useFeatureFlag('ENABLE_CSR_P13N.DIS-377')

    const csrPersonalization = {
        enabled: enableCSRPersonalization,
        marketChannel: mktChannel
    }

    return (
        <PromotionBanner promotionData={promotionData} csrPersonalization={csrPersonalization} />
    )
}
